import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/virtualBackground.tsx
var VirtualBackground = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M11.25 3.75H5.75C4.64543 3.75 3.75 4.64543 3.75 5.75V18.25C3.75 19.3546 4.64543 20.25 5.75 20.25H7.25647M20.25 12.75V18.25C20.25 19.3546 19.3546 20.25 18.25 20.25H16.7435M7.25647 20.25C7.38647 17.7429 9.46051 15.75 12 15.75C14.5395 15.75 16.6135 17.7429 16.7435 20.25M7.25647 20.25H16.7435M14.75 10.5C14.75 12.0188 13.5188 13.25 12 13.25C10.4812 13.25 9.25 12.0188 9.25 10.5C9.25 8.98122 10.4812 7.75 12 7.75C13.5188 7.75 14.75 8.98122 14.75 10.5Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ jsx("path", {
		d: "M19 1.75L17.9167 3.91667L15.75 5L17.9167 6.08333L19 8.25L20.0833 6.08333L22.25 5L20.0833 3.91667L19 1.75Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})] }) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.75 4.5C5.05964 4.5 4.5 5.05964 4.5 5.75V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H6.59077C7.02914 17.1142 9.00636 15.2673 11.4554 15.0266C11.6345 15.009 11.8162 15 12 15C12.2527 15 12.5014 15.017 12.7451 15.05C13.3168 15.1275 13.8607 15.2927 14.3625 15.5318C15.9287 16.2779 17.0864 17.7428 17.4092 19.5H18.25C18.9404 19.5 19.5 18.9404 19.5 18.25V12.75C19.5 12.3358 19.8358 12 20.25 12C20.6642 12 21 12.3358 21 12.75V18.25C21 19.7688 19.7688 21 18.25 21H16.7435H5.75037C4.23159 21 3 19.7688 3 18.25V5.75C3 4.23122 4.23122 3 5.75 3H11.25C11.6642 3 12 3.33579 12 3.75C12 4.16421 11.6642 4.5 11.25 4.5H5.75ZM8.5 10.5C8.5 8.567 10.067 7 12 7C13.933 7 15.5 8.567 15.5 10.5C15.5 12.433 13.933 14 12 14C10.067 14 8.5 12.433 8.5 10.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19 1C19.2841 1 19.5438 1.1605 19.6708 1.41459L20.6424 3.35765L22.5854 4.32918C22.8395 4.45622 23 4.71592 23 5C23 5.28408 22.8395 5.54378 22.5854 5.67082L20.6424 6.64235L19.6708 8.58541C19.5438 8.8395 19.2841 9 19 9C18.7159 9 18.4562 8.8395 18.3292 8.58541L17.3576 6.64235L15.4146 5.67082C15.1605 5.54378 15 5.28408 15 5C15 4.71592 15.1605 4.45622 15.4146 4.32918L17.3576 3.35765L18.3292 1.41459C18.4562 1.1605 18.7159 1 19 1Z",
		fill: "currentColor"
	})] })
});
//#endregion
export { VirtualBackground };
